import { useSelector } from 'react-redux'
import Layout from '../../UI/Layout/Layout'
import props from '../../../redux/props'
import Container from '../../UI/Container/Container'
import BackToCube from '../../UI/BackToCube/BackToCube'
// import VideoDefault from '../../UI/Video/Video'
import banner from '../../../assets/image/olaf/banner.webp'
// import { s3PublicStoragePrefix } from '../../../utility'
// import VideoPopup from '../../CubePageTemplate/Popup/VideoPopup/VideoPopup'
import Video from '../../CubePageTemplate/Popup/VideoPopup/Video'

declare global {
  interface Window {
    afopt: any
  }
}

const OlafTourPage: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  // const mobile = `${s3PublicStoragePrefix}custom-static-assets/videos/Aufsager/9x16/250109_SPD_Cube_Aufsager_Generell_9x16__FINAL_subbed.mp4`
  // const desktop = `${s3PublicStoragePrefix}custom-static-assets/videos/Aufsager/16x9/250109_SPD_Cube_Aufsager_Generell_16x9__FINAL_subbed.mp4`

  return (
    <Layout headerTransparent disableHeaderPadding>
      <Container className="py-5">
        <BackToCube />
        {/* <Video className="mt-8" mobile={mobile} desktop={desktop} /> */}
        <Video />
        <a href={t.olafTourPage.ctaLink} target="_blank" rel="noreferrer">
          <img src={banner} alt="Tour" className="w-full h-auto mt-5" />
        </a>
      </Container>
    </Layout>
  )
}

export default OlafTourPage
